/**
 * Initiate the Google Maps API autocomplete widget for the street address field for the Report Illicit Seller form.
 *
 * This will fetch address components for an Australian address and fill out individual fields on the form for better address consistency.
 *
 * For this code to work, set up your Contact Form 7 form with these criteria:
 *
 * - Wrap all fields in a div with the ID #report-seller-form
 * - Have a text field with the name "retail-outlet-address-line-1" to be used as the autocomplete widget.
 * - Wrap address line 2, state/territory, and postcode fields in a #hidden-address-fields div which is hidden by default.
 *
 * Fetching only address components and limiting predictions to one country should limit API usage.
 */
function initGoogleMapsApi() {
    var addressInput = document.querySelector('#report-seller-form input[name="retail-outlet-address-line-1"]');
    if (addressInput) {
        var autocomplete = new google.maps.places.Autocomplete(addressInput, {
            componentRestrictions: {
                country: 'au'
            },
            fields: ['address_components']
        });

        autocomplete.addListener('place_changed', function () {
            var addressLine1 = '';
            var addressLine2 = '';
            var stateOrTerritory = '';
            var postcode = 0;

            var place = autocomplete.getPlace();
            var addressComponents = place.address_components;
            for (var componentIndex = 0; componentIndex < addressComponents.length; componentIndex++) {
                var component = addressComponents[componentIndex];
                var componentType = component.types[0];

                if (componentType === 'street_number') {
                    if (addressLine1 !== '') {
                        addressLine1 = (component.long_name + ' ' + addressLine1);
                    } else {
                        addressLine1 = component.long_name;
                    }
                }

                if (componentType === 'route') {
                    if (addressLine1 !== '') {
                        addressLine1 += (' ' + component.long_name);
                    } else {
                        addressLine1 = component.long_name;
                    }
                }

                if (componentType === 'locality') {
                    if (addressLine2 !== '') {
                        addressLine2 += (', ' + component.long_name);
                    } else {
                        addressLine2 = component.long_name;
                    }
                }

                if (componentType === 'sublocality') {
                    if (addressLine2 !== '') {
                        addressLine2 = (component.long_name + ', ' + addressLine2);
                    } else {
                        addressLine2 = component.long_name;
                    }
                }

                if (componentType === 'administrative_area_level_1') {
                    stateOrTerritory = component.short_name;
                }

                if (componentType === 'postal_code' && !isNaN(component.long_name)) {
                    postcode = Number(component.long_name);
                }
            }

            addressInput.value = addressLine1;

            if (addressLine2 !== '') {
                var addressLine2Field = document.querySelector('#report-seller-form input[name="retail-outlet-address-line-2"]');
                addressLine2Field.value = addressLine2;
            }

            if (stateOrTerritory !== '') {
                var stateOrTerritoryField = document.querySelector('#report-seller-form input[name="retail-outlet-address-state-territory"]');
                stateOrTerritoryField.value = stateOrTerritory;
            }

            if (postcode > 0 && postcode <= 9999) {
                var postcodeField = document.querySelector('#report-seller-form input[name="retail-outlet-address-postcode"]');
                postcodeField.value = postcode;
            }

            var hiddenFieldsParent = document.querySelector('#report-seller-form #hidden-address-fields');
            hiddenFieldsParent.classList.remove('d-none');
        });
    }
}

window.addEventListener('load', function () {
    initGoogleMapsApi();

    // Show options to select additional products being sold after the first involvement option is selected.
    var firstInvolvementDropdown = document.querySelector('#report-seller-form select[name="involvement"]');
    if (firstInvolvementDropdown) {
        firstInvolvementDropdown.addEventListener('change', function () {
            var secondProductsRow = document.querySelector('#report-seller-form #additional-products-row-2');
            secondProductsRow.classList.remove('d-none');

            // Show a third and final options row if the second row has an involvement option selected.
            var secondInvolvementDropdown = document.querySelector('#report-seller-form select[name="involvement-2"]');
            secondInvolvementDropdown.addEventListener('change', function () {
                var thirdProductsRow = document.querySelector('#report-seller-form #additional-products-row-3');
                thirdProductsRow.classList.remove('d-none');
            });
        });
    }

    var formElement = document.querySelector('form:has(#report-seller-form)');
    if (formElement) {
        formElement.addEventListener('submit', function () {
            if (typeof gtag === 'function') {
                gtag('event', 'report_seller');
            }
        });
    }
});